import React, { useEffect, useState } from 'react';
import "../App.css";
import Dropdown from './Dropdown'; 
import { useNavigate } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import BarChartIcon from '@mui/icons-material/BarChart';
import PeopleIcon from '@mui/icons-material/PeopleAlt';
import LaptopIcon from '@mui/icons-material/Laptop';
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
const TopBar = () => {
  const {t, i18n} =useTranslation();
  const navigate = useNavigate(); // Hook for navigation
  const [isDashboardPage, setIsDashboardPage] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem('language') || 'en');
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    // Load saved language and update both i18n and state
    const savedLanguage = localStorage.getItem('language') || 'en';
    i18n.changeLanguage(savedLanguage);
    setCurrentLanguage(savedLanguage);
  }, []); // Only run once on component mount

  useEffect(() => {
    const handleLocationChange = () => {
      const currentPage = window.location.pathname;
      setIsDashboardPage(currentPage.includes('dash'));
    };

    handleLocationChange();
    window.addEventListener('popstate', handleLocationChange);

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleIconClick = () => {
    navigate('/'); // Redirect to home page
};

const languageOptions = [
  { code: "en", name: "English" },
  { code: "es", name: "Español" }
];
const handleDropdownChange = (value) => {
  const selectedLanguage = languageOptions.find(option => option.name === value);
  if (selectedLanguage) {
    i18n.changeLanguage(selectedLanguage.code);
    localStorage.setItem('language', selectedLanguage.code);
    setCurrentLanguage(selectedLanguage.code);
  }
};

  return (
    <header style={{
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "space-between", 
      backgroundColor: 'var(--primary-color)',
      color: 'var(--primary-white-color)',
      padding: "0 20px",
      boxSizing: "border-box",
      position: isScrolled ? 'fixed' : 'relative',
      top: isScrolled ? 0 : 'auto',
      left: isScrolled ? 0 : 'auto',
      width: isScrolled ? '100%' : 'auto',
      zIndex: isScrolled ? 1000 : 'auto',
    }}>
      {/*Icon*/}
      <div style={{ flex: "0 0 auto" }} onClick={() => navigate('./')}>
        <img 
          src={`${process.env.PUBLIC_URL}/AppIcon.png`}
          onClick={handleIconClick}
          alt="App Icon" 
          style={{ 
            height: "clamp(40px, 7vh, 80px)", 
            width: "auto",  
            maxHeight: "80%",
            cursor: 'pointer'
          }} 
        />
                  <div style={{ fontSize: '0.8rem', color: 'var(--primary-white-color)', marginTop: '-10px' }}>
                    {t('home')}
                  </div>
      </div>

       {/*Header text*/}
       <h1 style={{
        flex: "1", 
        textAlign: "center",
        fontSize: "clamp(1.5rem, 2vw, 2rem)", 
        fontWeight: "bold",
        fontFamily: "KomikaAxis", 
        margin: 0
      }}>
        {t(isDashboardPage ? 'topBarDash' : 'topBarProfile')}
      </h1>


      <div onClick={() => navigate('/dashsummary')} style={{ cursor: 'pointer', textAlign: 'center', marginLeft: '55px' }}>
                  <BarChartIcon 
                    style={{ fontSize: '50px', color: 'var(--primary-white-color)' }} 
                  />
                  <div style={{ fontSize: '0.8rem', color: 'var(--primary-white-color)', marginTop: '-5px' }}>
                    {t('topBarDash')}
                  </div>
                </div>
                <div onClick={() => navigate('/start')} style={{ cursor: 'pointer', textAlign: 'center', marginLeft: '55px' }}> 
                  <PeopleIcon 
                    style={{ fontSize: '50px', color: 'var(--primary-white-color)' }} 
                  />
                  <div style={{ fontSize: '0.8rem', color: 'var(--primary-white-color)', marginTop: '-5px' }}>
                    {t('profile')}
                  </div>
                </div>

                <div onClick={() => navigate('/prototype')} style={{ cursor: 'pointer', textAlign: 'center', marginLeft: '55px' }}> 
                <LaptopIcon 
                    style={{ fontSize: '40px', color: 'var(--primary-white-color)' }} 
                  />
                  <AppleIcon 
            style={{ fontSize: '40px', color: 'var(--primary-white-color)' }} 
          />
          <AndroidIcon 
            style={{ fontSize: '40px', color: 'var(--primary-white-color)' }} 
          />
                  <div style={{ fontSize: '0.8rem', color: 'var(--primary-white-color)', marginTop: '-5px' }}>
                    {t('prototype')}
                  </div>
                </div> 
     
      
      {/*  <div onClick={() => window.open('https://demointegra.dicapta.com/', '_blank')}  style={{ cursor: 'pointer', textAlign: 'center', marginLeft: '15px' }}> 
          <LaptopIcon 
            style={{ fontSize: '80px', color: 'var(--primary-white-color)' }} 
          />
          <div style={{ fontSize: '1rem', color: 'var(--primary-white-color)', marginTop: '-10px' }}>
            {t('web')}
          </div>
        </div> 

        <div onClick={() => window.open('https://apps.apple.com/us/app/integra-video/id6670761608', '_blank')}  style={{ cursor: 'pointer', textAlign: 'center', marginLeft: '55px' }}> 
          <AppleIcon 
            style={{ fontSize: '80px', color: 'var(--primary-white-color)' }} 
          />
          <div style={{ fontSize: '1rem', color: 'var(--primary-white-color)', marginTop: '-10px' }}>
            {t('iPhone')}
          </div>
        </div> 
        <div  onClick={() => window.open('https://play.google.com/store/apps/details?id=com.dicapta.integraapp', '_blank')} style={{ cursor: 'pointer', textAlign: 'center', marginLeft: '55px' }}>
          <AndroidIcon 
            style={{ fontSize: '80px', color: 'var(--primary-white-color)' }} 
          />
          <div style={{ fontSize: '1rem', color: 'var(--primary-white-color)', marginTop: '-10px' }}>
            {t('Android')}
          </div>
        </div> 
      */}
      {/* Language Dropdown */}
      <div style={{ flex: "0 0 auto", marginLeft: '50px' }}>
      <Dropdown 
        label={t('language')}
        options={languageOptions.map(option => option.name)} //Show name of languages
        onChange={handleDropdownChange} 
        value={languageOptions.find(option => option.code === currentLanguage)?.name || 'English'}
      />
      </div>
    </header>
  );
};

export default TopBar;
